import React from 'react';
import StripeLogo from '../../assets/Payment-Logos/stripe-logo.svg';
import { LuSettings } from "react-icons/lu";

export default function HostPayoutStatusCard({
  payoutStatus,
  stripeLoginUrl,
  onSetupStripe,
}) {
  if (!payoutStatus) return null;

  const {
    stripeConnected,
    stripeBankConnected,
    stripePayoutsEnabled,
  } = payoutStatus;

  const isActive =
    stripeConnected && stripeBankConnected && stripePayoutsEnabled;

  const headline = isActive
    ? 'Manage on Stripe'
    : 'Stripe payouts not set up';

  const description = isActive
    ? 'Payouts are processed securely through Stripe. Manage your bank and payout details directly on Stripe.'
    : 'We use Stripe to process host payouts. Set up Stripe to add your bank account and receive payouts.';

  return (
    <div style={ui.card}>
      {/* Logo */}
      <img src={StripeLogo} alt="Stripe" style={ui.logo} />

      {/* Headline */}
      <div style={ui.title}>{headline}</div>

      {/* Description */}
      <div style={ui.description}>{description}</div>

      {/* Action */}
      {isActive && stripeLoginUrl ? (
        <a
          href={stripeLoginUrl}
          target="_blank"
          rel="noopener noreferrer"
          style={ui.primaryBtn}
        >
          <LuSettings size={14} style={ui.btnIcon} />
          Payout settings
        </a>
      ) : (
        <button
          type="button"
          onClick={onSetupStripe}
          style={ui.primaryBtn}
        >
          <LuSettings size={14} style={ui.btnIcon} />
          Set up payouts
        </button>
      )}
    </div>
  );
}

/* ===============================
   PAYMENT / ADMIN CARD STYLE
================================ */

const ui = {
  card: {
    border: '1px solid #fefefe',
    borderRadius: 16,
    background: '#fff',
    padding: '20px 16px',
    marginBottom: 20,
    textAlign: 'center',
  },

  logo: {
    width: 48,
    height: 'auto',
    marginBottom: 10,
  },

  title: {
    fontSize: 14,
    fontWeight: 900,
    color: '#0b0b0b',
    marginBottom: 6,
  },

  description: {
    fontSize: 13,
    color: '#6B7280',
    lineHeight: 1.45,
    marginBottom: 14,
    maxWidth: 420,
    marginLeft: 'auto',
    marginRight: 'auto',
  },

  primaryBtn: {
    border: '1px solid #ddd',
    background: '#ddd',
    color: '#000000ff',
    fontSize: 10,
    fontWeight: 900,
    padding: '9px 14px',
    borderRadius: 999,
    cursor: 'pointer',
    textDecoration: 'none',
    display: 'inline-flex',          // 👈 important
    alignItems: 'center',
    gap: 6,                          // 👈 space between icon and text
  },

  btnIcon: {
    display: 'block',
  },
};
